export enum GradeKey {
  GREENY = 'user_grade_greeny',
  BEGINNER = 'user_grade_beginner',
  LIGHT = 'user_grade_light',
  STANDARD = 'user_grade_standard',
  SILVER = 'user_grade_silver',
  GOLD = 'user_grade_gold',
  PREMIUM = 'user_grade_premium',
  VIP = 'user_grade_vip',
  GYYM_MASTER = 'user_grade_gyym_master',
}

export interface Grade {
  key: GradeKey
  name: string
  monthlyReservationNumToAchieve: number
  monthlyReservationNumToKeep: number
}

export type GradesListResponse = (Grade & {
  pointReturnRate: number
  reservationLimit: number
})[]
